import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";
import Heander from "../HeaderPortalVendedor";
import { MudaVisibilidade } from "../../services/funcoes";
import { Container, HomeFornada } from "./styles";
import {
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
  MDBIcon,
} from "mdbreact";

// import "react-datepicker/dist/react-datepicker.css";
import Carregando from "../../Componentes/Carregando";
import MenuPrinc from "../../Componentes/MenuPrinc";

import Icongerente from "../../Images/icon-gerente.png";
import Iconvendedor from "../../Images/icon-vendedor.png";
import Iconsupervisor from "../../Images/icon-supervisor.png";

import ReactExport from "react-data-export";
import { URLBunge } from "../../Componentes/Config";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let arquivo = [];
const TOKEN = localStorage.getItem("c_token");
const EMAIL_USUARIO = localStorage.getItem("c_email");
class Home extends Component {
  state = {
    cnpj: "",
    departamento: "",
    CNPJ: "",
    SAP: "",
    gerente: "",
    gerenteId: 0,
    gerenteUsuario: "",
    lojaId: 0,
    supervisor: "",
    supervisorId: 0,
    supervisorUsuario: "",
    vendedor: "",
    vendedorId: 0,
    vendedorUsuario: "",

    ListaSupervisores: [],
    ListaVendedores: [],
    ListaGerentes: [],

    textGer: "",
    textSub: "",
    textVend: "",
    nomearquivo: "Escolha o Arquivos",
    erros: [],
    loading: false,
  };

  async componentDidMount() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var departamento = await fetch(
      `${URLBunge}/api/AdminVendedor/DadosUser/${2329681}/${EMAIL_USUARIO}`,
      requestOptions
    ).then((response) => response.json());
    if (departamento.sucesso === false) {
      this.setState({ departamento: departamento.mensagem });
    }

    this.Vendedores();
  }

  Vendedores = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var Vendes = await fetch(
      `${URLBunge}/api/Vendedores/ProcuraVendedores/` + EMAIL_USUARIO,
      requestOptions
    ).then((response) => response.json());

    if (Vendes.gerentes != null) {
      this.setState({ ListaGerentes: Vendes.gerentes });
      this.setState({ ListaSupervisores: Vendes.supervisores });
      this.setState({ ListaVendedores: Vendes.vendedores });
    }
  };

  EscolheGer = async (id, nome) => {
    this.setState({
      gerenteId: id,
      gerente: nome,
    });
  };

  EscolheSup = async (id, nome) => {
    this.setState({
      supervisorId: id,
      supervisor: nome,
    });
  };

  EscolheVend = async (id, nome) => {
    this.setState({
      vendedorId: id,
      vendedor: nome,
    });
  };

  CarregaLoja = async () => {
    this.setState({ loading: true });
    var dados = {
      SAP: this.state.SAP,
      CNPJ: this.state.CNPJ,
    };
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "POST",
      body: JSON.stringify(dados),
      headers: myHeaders,
      redirect: "follow",
    };
    var CNPJ = await fetch(
      `${URLBunge}/api/Vendedores/ListaVinculo`,
      requestOptions
    ).then((response) => response.json());

    if (CNPJ.sucesso) {
      MudaVisibilidade("dados");
      this.setState({
        gerente: CNPJ.gerente,
        gerenteId: CNPJ.gerenteId,
        gerenteUsuario: CNPJ.gerenteUsuario,
        lojaId: CNPJ.lojaId,
        supervisor: CNPJ.supervisor,
        supervisorId: CNPJ.supervisorId,
        supervisorUsuario: CNPJ.supervisorUsuario,
        vendedor: CNPJ.vendedor,
        vendedorId: CNPJ.vendedorId,
        vendedorUsuario: CNPJ.vendedorUsuario,
      });
    } else {
      Swal.fire({
        icon: "info",
        title: "Atenção!",
        text: CNPJ.mensagem,
      });
    }
    this.setState({ loading: false });
  };

  AlteraArquitetura = async () => {
    this.setState({ loading: true });
    var dados = {
      LojaId: this.state.lojaId,
      GerenteId: this.state.gerenteId,
      SupervisorId: this.state.supervisorId,
      VendedorId: this.state.vendedorId,
    };
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(dados),
      redirect: "follow",
    };

    var Altera = await fetch(
      `${URLBunge}/api/Vendedores/AtualizaVinculo/`,
      requestOptions
    ).then((response) => response.json());
    //console.log('TESTE Altera', Altera);
    if (Altera.data.sucesso) {
      Swal.fire({
        icon: "success",
        title: "Tudo certo!",
        text: "Alterado com sucesso!",
      }).then(function () {
        this.CarregaLoja(this.state.CNPJ);
        window.location.href = "/Comercial";
      });
      //window.location =  '/Comercial'
      this.setState({ loading: false });
    } else {
      Swal.fire({
        icon: "info",
        title: "Atenção!",
        text: Altera.data.mensagem,
      });

      this.setState({ loading: false });
    }
  };

  toggle = (nr, respostas) => {
    if (respostas != null && respostas != undefined) {
      var resp = respostas;
      this.setState({ cpf: resp.cpf });
      this.setState({ questionRespostas: resp.respostas });
    }

    let modalNumber = "modal" + nr;
    this.setState({ [modalNumber]: !this.state[modalNumber] });
  };

  LeArquivo = async (e) => {
    var a = e.target.id;
    var nome = e.target.files[0].name.split(".");
    nome = nome[0];
    this.setState({ nomearquivo: nome });

    if (e.target.files[0].name.indexOf("xlsx") != -1) {
      arquivo[a] = e.target.files[0];

      if (!arquivo[a]) {
        return;
      }

      var reader = new FileReader();
      reader.onload = (e) => {
        console.log(reader.result);
      };
      reader.readAsDataURL(arquivo[a]);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Arquivo selecionado não é um Excel",
      });
      this.setState({ nomearquivo: "Escolha o Arquivos" });
      return;
    }
  };

  CadastrarArquivo = async () => {
    this.setState({ loading: true });

    var dataCad = new FormData();

    await dataCad.append(`idProjeto`, 2329681);
    var XlsName = "";
    if (arquivo["XLSFile"]) {
      await dataCad.append(
        `ArquivoExcel`,
        arquivo["XLSFile"],
        arquivo["XLSFile"].name
      );
      XlsName = arquivo["XLSFile"].name;
    }

    var defaultOptions = {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        "Cache-Control": "no-cache",
        Authorization: "bearer " + TOKEN,
      },
      method: "POST",
      body: dataCad,
    };
    const UploadArquivo = await fetch(
      `${URLBunge}/api/AdminVendedor/ImportaExcel`,
      defaultOptions
    );

    let danger = UploadArquivo.data.usuariosComErros;
    let msg = UploadArquivo.data.mensagem;
    let botao = "OK";

    if (UploadArquivo.status === 200) {
      if (danger.length > 0) {
        this.setState({ loading: false });
        this.setState({ erros: UploadArquivo.data.usuariosComErros });
        console.log("TESTE ERROS:", this.state.erros);
        msg =
          "Arquivo comercial processado com sucesso, porém contem alguns erros!";
        botao = "Consultar erros";

        Swal.fire({
          icon: "success",
          title: "Atenção",
          confirmButtonText: botao,
          text: msg,
        }).then((result) => {
          if (result.isConfirmed) {
            this.toggle(4);
            this.toggle(5);
            this.setState({ nomearquivo: "Escolha o Arquivos" });
          }
        });
        return;
      }

      Swal.fire({
        icon: "success",
        title: "Feito!",
        confirmButtonText: botao,
        text: msg,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location = "/Comercial";
        }
      });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: UploadArquivo.data.mensagem,
      });
    }

    this.setState({ loading: false });
  };

  render() {
    return (
      <Container>
        <Heander />
        <MenuPrinc />

        {this.state.loading && <Carregando />}
        <HomeFornada>
          <div className="clear"></div>

          <div className="cadastros">
            <h1>Arquitetura Comercial</h1>

            <MDBBtn
              color="primary"
              size="md"
              onClick={() => this.toggle(4)}
              className="pull-right"
            >
              Cadastrar por planilha
            </MDBBtn>

            <div id="filtro">
              <input
                type="text"
                value={this.state.CNPJ}
                onChange={(e) => {
                  this.setState({ CNPJ: e.target.value });
                }}
                placeholder="Informe o CNPJ"
              />
              <input
                type="text"
                value={this.state.SAP}
                onChange={(e) => {
                  this.setState({ SAP: e.target.value });
                }}
                placeholder="ou Informe o SAP"
              />
              <MDBBtn
                color="primary"
                size="md"
                onClick={() => this.CarregaLoja()}
              >
                Pesquisar
              </MDBBtn>
            </div>

            <div id="dados">
              <form>
                <section>
                  <img src={Icongerente} alt="" className="img" />
                  <h2>Gerente</h2>
                  <strong>{this.state.gerente}</strong>
                  <MDBBtn
                    color="dark-green"
                    size="sm"
                    onClick={() => this.toggle(1)}
                  >
                    <MDBIcon icon="pencil-alt" />
                  </MDBBtn>
                </section>

                <section>
                  <img src={Iconsupervisor} alt="" className="img" />
                  <h2>Supervisor</h2>
                  <strong>{this.state.supervisor}</strong>
                  <MDBBtn
                    color="dark-green"
                    size="sm"
                    onClick={() => this.toggle(2)}
                  >
                    <MDBIcon icon="pencil-alt" />
                  </MDBBtn>
                </section>

                <section>
                  <img src={Iconvendedor} alt="" className="img" />
                  <h2>Vendedor</h2>
                  <strong>{this.state.vendedor}</strong>
                  <MDBBtn
                    color="dark-green"
                    size="sm"
                    onClick={() => this.toggle(3)}
                  >
                    <MDBIcon icon="pencil-alt" />
                  </MDBBtn>
                </section>

                <div className="buttons">
                  <MDBBtn
                    color="primary"
                    size="md"
                    onClick={() => this.AlteraArquitetura()}
                  >
                    Alterar arquitetura comercial
                  </MDBBtn>
                </div>
              </form>
            </div>
          </div>

          {/* GERENTE */}
          <MDBModal
            isOpen={this.state.modal1}
            toggle={() => this.toggle(1)}
            size="lg"
          >
            <MDBModalHeader toggle={() => this.toggle(1)}>
              Editar Gerente
            </MDBModalHeader>
            <MDBModalBody>
              <form className="oft">
                <MDBRow>
                  <MDBCol md="12">
                    <MDBRow>
                      <div className="campos100">
                        <label>Pesquise pelo nome</label>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            id="codigo-sap"
                            value={this.state.textGer}
                            onChange={(e) =>
                              this.setState({ textGer: e.target.value })
                            }
                            placeholder=""
                          />
                        </div>
                        <label>Escolha o Gerente</label>
                        <div className="selects">
                          {this.state.ListaGerentes.map((ger, i) => {
                            if (
                              ger.nome
                                .toUpperCase()
                                .indexOf(this.state.textGer.toUpperCase()) < 0
                            ) {
                              return;
                            }
                            return (
                              <div
                                className="custom-control custom-checkbox"
                                key={i}
                              >
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  value={ger.id}
                                  id={"ger" + ger.id}
                                  onChange={(e) =>
                                    this.EscolheGer(ger.id, ger.nome)
                                  }
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={"ger" + ger.id}
                                >
                                  {ger.nome}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </MDBRow>
                  </MDBCol>
                </MDBRow>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn
                color="secondary"
                size="sm"
                onClick={() => this.toggle(1)}
              >
                Fechar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModal>

          {/* SUPERVISOR */}
          <MDBModal
            isOpen={this.state.modal2}
            toggle={() => this.toggle(2)}
            size="lg"
          >
            <MDBModalHeader toggle={() => this.toggle(2)}>
              Editar Supervisor
            </MDBModalHeader>
            <MDBModalBody>
              <form className="oft">
                <MDBRow>
                  <MDBCol md="12">
                    <MDBRow>
                      <div className="campos100">
                        <label>Pesquise pelo nome</label>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            id="codigo-sap"
                            value={this.state.textSub}
                            onChange={(e) =>
                              this.setState({ textSub: e.target.value })
                            }
                            placeholder=""
                          />
                        </div>
                        <label>Escolha o Supervisor</label>
                        <div className="selects">
                          {this.state.ListaSupervisores.map((sup, i) => {
                            if (
                              sup.nome
                                .toUpperCase()
                                .indexOf(this.state.textSub.toUpperCase()) < 0
                            ) {
                              return;
                            }
                            return (
                              <div
                                className="custom-control custom-checkbox"
                                key={i}
                              >
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  value={sup.id}
                                  id={"ger" + sup.id}
                                  onChange={(e) =>
                                    this.EscolheSup(sup.id, sup.nome)
                                  }
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={"ger" + sup.id}
                                >
                                  {sup.nome}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </MDBRow>
                  </MDBCol>
                </MDBRow>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn
                color="secondary"
                size="sm"
                onClick={() => this.toggle(2)}
              >
                Fechar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModal>

          {/* VENDEDOR */}
          <MDBModal
            isOpen={this.state.modal3}
            toggle={() => this.toggle(3)}
            size="lg"
          >
            <MDBModalHeader toggle={() => this.toggle(3)}>
              Editar Vendedor
            </MDBModalHeader>

            <MDBModalBody>
              <form className="oft">
                <MDBRow>
                  <MDBCol md="12">
                    <MDBRow>
                      <div className="campos100">
                        <label>Pesquise pelo nome</label>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            id="codigo-sap"
                            value={this.state.textVend}
                            onChange={(e) =>
                              this.setState({ textVend: e.target.value })
                            }
                            placeholder=""
                          />
                        </div>
                        <label>Escolha o Vendedor</label>
                        <div className="selects">
                          {this.state.ListaVendedores.map((vend, i) => {
                            if (
                              vend.nome
                                .toUpperCase()
                                .indexOf(this.state.textVend.toUpperCase()) < 0
                            ) {
                              return;
                            }
                            return (
                              <div
                                className="custom-control custom-checkbox"
                                key={i}
                              >
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  value={vend.id}
                                  id={"vend" + vend.id}
                                  onChange={(e) =>
                                    this.EscolheVend(vend.id, vend.nome)
                                  }
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={"vend" + vend.id}
                                >
                                  {vend.nome}
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </MDBRow>
                  </MDBCol>
                </MDBRow>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn
                color="secondary"
                size="sm"
                onClick={() => this.toggle(3)}
              >
                Fechar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModal>

          {/* ARQUIVO */}
          <MDBModal
            isOpen={this.state.modal4}
            toggle={() => this.toggle(4)}
            size="md"
          >
            <MDBModalHeader toggle={() => this.toggle(4)}>
              Cadastro de Usuários
            </MDBModalHeader>
            <MDBModalBody>
              <MDBRow>
                <MDBCol md="12">
                  <a
                    href="https://www.plataformaomnion.com.br/ExcelBunge/padrao.zip"
                    target="_blank"
                    className="exe"
                  >
                    Baixar modelo de arquivo
                  </a>
                </MDBCol>

                <MDBCol md="12">
                  <form>
                    <label>Upload do arquivo</label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span
                          className="input-group-text"
                          id="inputGroupFileAddon01"
                        >
                          Upload
                        </span>
                      </div>

                      <div className="custom-file">
                        <input
                          type="file"
                          className="custom-file-input"
                          id="XLSFile"
                          aria-describedby="inputGroupFileAddon01"
                          accept="xlsx/*"
                          onChange={(e) => this.LeArquivo(e)}
                        />
                        <label className="custom-file-label" htmlFor="XLSFile">
                          {this.state.nomearquivo}
                        </label>
                      </div>
                    </div>
                    <small>Extensão .xlsx</small>
                  </form>
                </MDBCol>
              </MDBRow>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn
                color="primary"
                size="md"
                onClick={() => this.CadastrarArquivo()}
              >
                Cadastrar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModal>

          {/* MODAL DE ERRO */}
          <MDBModal
            isOpen={this.state.modal5}
            toggle={() => this.toggle(5)}
            size="fluid"
          >
            <MDBModalHeader toggle={() => this.toggle(5)}>
              Erros de importação
            </MDBModalHeader>
            <MDBModalBody>
              <MDBRow>
                <MDBCol md="12">
                  <ExcelFile
                    element={
                      <MDBBtn
                        color="primary"
                        size="sm"
                        style={{ float: "right" }}
                      >
                        Exportar em Excel
                      </MDBBtn>
                    }
                  >
                    <ExcelSheet data={this.state.erros} name="Employees">
                      <ExcelColumn label="SAP" value="sap" />
                      <ExcelColumn label="Email Gerente" value="emailGerente" />
                      <ExcelColumn
                        label="Email Supervisor"
                        value="emailSupervisor"
                      />
                      <ExcelColumn
                        label="Email Vendedor"
                        value="emailVendedor"
                      />
                      <ExcelColumn label="Mensagem" value="mensagem" />
                    </ExcelSheet>
                  </ExcelFile>

                  <MDBTable striped>
                    <MDBTableHead>
                      <tr>
                        <th>SAP</th>
                        <th>Email gerente</th>
                        <th>Email Supervisor</th>
                        <th>Email Vendedor</th>
                        <th>Mensagem</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      {this.state.erros.length > 0 ? (
                        this.state.erros.map((erro, i) => (
                          //erro.emailGerente == null ? " - " : erro.emailGerente

                          <tr>
                            <td>{erro.sap}</td>
                            <td>
                              {erro.emailGerente == null
                                ? " - "
                                : erro.emailGerente}
                            </td>
                            <td>
                              {erro.emailSupervisor == null
                                ? " - "
                                : erro.emailSupervisor}
                            </td>
                            <td>
                              {erro.emailVendedor == null
                                ? " - "
                                : erro.emailVendedor}
                            </td>
                            <td>
                              {erro.mensagem == null ? " - " : erro.mensagem}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4">Sem informações</td>
                        </tr>
                      )}
                    </MDBTableBody>
                  </MDBTable>
                </MDBCol>
              </MDBRow>
            </MDBModalBody>
          </MDBModal>
        </HomeFornada>
      </Container>
    );
  }
}

export default withRouter(Home);
